export interface Banque {
  id: number;
  client_id: number;
  station_id: number;
  nom: string;
  swift: string | null;
  designation: string | null;
  agence: string | null;
  rib: string;
  logo: string;
  date_update: string;
  statut: boolean;
}

export interface BankAccount extends Banque {
  id: number | null;
}

export interface BanqueResponse {
  success: boolean;
  banques: Banque[];
}